/*
  Main File, 1st file to execute in project
*/

import React from 'react';
import { createRoot } from 'react-dom/client';
import BootSetup from 'BootSetup'

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<BootSetup/>);